<template>
  <v-layout row>
    <v-flex
      xs12
      class="px-0 pt-0 pb-2"
    >
      <v-card
        ripple
        :class="isConnected"
        :to="link"
      >
        <v-card-text class="text-truncate">
          <span class="body-2 icon-text-offset">
            <slot />
          </span>
          <v-icon right>mdi-arrow-top-right</v-icon>
        </v-card-text>
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
export default {
  props: {
    link: {
      type: String,
      default: "/",
    },
    connected: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    isConnected: function () {
      if (!this.connected) {
        return "red";
      } else {
        return "";
      }
    },
  },
};
</script>

<style></style>
